import { Claims } from "../constants/authentication/claims";
import * as Enumerable from 'linq';
var UserRoleAndClaimsHelper = /** @class */ (function () {
    function UserRoleAndClaimsHelper() {
    }
    UserRoleAndClaimsHelper.HasAccessPermissionsPagePermission = function (userClaims) {
        return Enumerable.from(userClaims).any(function (x) { return x.permission == Claims.CanAccessPermissions; });
    };
    UserRoleAndClaimsHelper.HasShareQueriesGloballyPermission = function (userClaims) {
        return Enumerable.from(userClaims).any(function (x) { return x.permission == Claims.ShareGlobally; });
    };
    UserRoleAndClaimsHelper.IsCurrentRoleAdmin = function (user) {
        return user.roleName == "Admin";
    };
    return UserRoleAndClaimsHelper;
}());
export { UserRoleAndClaimsHelper };
